import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    autocomplete: {
      width: '100%',
      '& .MuiTextField-root': {
        width: 'inherit',
        margin: 0,
      },
      '& .MuiAutocomplete-inputRoot': {
        paddingTop: theme.spacing(0.5),
        paddingBottom: theme.spacing(0.5),
      },

      '& .MuiChip-root': {
        backgroundColor: '#FFF',

        '& .MuiTypography-root': {
          fontWeight: 600,
          fontSize: '1.4rem',
          color: '#727970',
        },

        '& .MuiChip-deleteIcon': {
          color: '#414940',
          '& .MuiSvgIcon-root': {
            width: 18,
          },
        },
      },
    },
    memberSelected: {
      '& > p': {
        fontWeight: 600,
        marginBottom: theme.spacing(-0.6),
      },
      '& > h6': {
        color: '#727970',
      },
    },
  }),
)
